module.exports = __webpack_public_path__ + "img/2.460519fe.webp";